import { createContext } from "react";

export type MapTransform = {
    position: { x: number; y: number };
    scale: number;
};

export type MapState = {
    transform: MapTransform;
    setTransform: React.Dispatch<React.SetStateAction<MapTransform>>;
};

const MapContext = createContext<MapState>({
    transform: { position: { x: 0, y: 0 }, scale: 1 },
    setTransform: () => {},
});

export { MapContext };
